import React, { useState } from "react";
import { Button } from "../../atoms/button";
import { useDispatch, useSelector } from "react-redux";
import { CustomHeadline } from "../../atoms/custom-headline";
import {
  EMAIL_OTP_HEADLINE,
  ENTER_OTP,
  UPDATE_SIGN_UP,
  UPDATE_SINGLE_SIGN_ON,
  VERIFY_SIGN_IN_BUTTON,
  SIGN_UP_SUCCESS,
} from "../../../../../constants";
import { ErrorMessage } from "../../atoms/error-message";
import {
  getErrorStyle,
  triggerUpdateWithOtp,
  triggerSignUp,
  genericError,
  triggerSSO,
  inputFieldError,
  retrieveNumbers,
} from "../../util";
import get from "lodash/get";
import "./otp-screen.module.css";
import { ResendOtp } from "../../atoms/resend-otp";
import { checkIfSingleSignOn } from "../../sso-utils";
import { SuccessMessage } from "../../atoms/success-message";
import { AgreementText } from "../../atoms/agreement-text";

export const EmailOtpScreen = ({ mode, isUserLoginPage = false, displayData = "" }) => {
  const { signUp = {}, singleSignOn = {} } = useSelector((state) => get(state, ["login"], {}));
  const { currentPath = "", currentHostUrl = "" } = useSelector((state) => get(state, ["qt"], {}));
  const { inputData, name, password } = get(signUp, ["userData"], {});
  const { inputData: ssoInputData, name: ssoName, password: ssoPassword } = get(singleSignOn, ["userData"], {});
  const { general = {}, login = {} } = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config"], {}));
  const { signupSuccess = "" } = get(login, ["pageSetting"], {});
  const { agreementText, enterOtpTitle, enterOtpLabel, resendOtpLabel, resendOtpInLabel, button } = get(
    login,
    ["email-otp", "rows", 0, "config"],
    {}
  );
  const { sso = {} } = general;
  const [response, setResponse] = useState(null);
  const [api, setApi] = useState(null);
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(null);
  const [displaySuccess, setSuccess] = useState(false);
  const updatedInputData = !isUserLoginPage ? inputData : ssoInputData;
  const updatedName = !isUserLoginPage ? name : ssoName;
  const updatedPassword = !isUserLoginPage ? password : ssoPassword;

  const triggerOnEdit = () =>
    dispatch({
      type: !isUserLoginPage ? UPDATE_SIGN_UP : UPDATE_SINGLE_SIGN_ON,
      payload: {
        currentScreen: "signUp",
        userData: { inputData: updatedInputData, name: updatedName, password: updatedPassword },
      },
    });

  const triggerHandler = async () => {
    const signUpProps = { email: updatedInputData, name: updatedName, password: updatedPassword };
    const { responseStatus: signUpResponse, qtAuthCookie } = await triggerSignUp(signUpProps);
    if (signUpResponse !== 409) {
      setResponse(signUpResponse);
      setApi("sign-up");
    }
    if (signUpResponse === 200 || signUpResponse === 409) {
      const updateOtpProps = { email: updatedInputData, otp: otp, authCookie: qtAuthCookie };
      const updateWithOtpResponse = await triggerUpdateWithOtp(updateOtpProps);
      setResponse(updateWithOtpResponse);
      setApi("update-with-otp");
      if (updateWithOtpResponse === 200) {
        if (isUserLoginPage && checkIfSingleSignOn(sso) && window?.location) {
          const ssoProps = { sso: sso, currentHostUrl: currentHostUrl, currentPath: currentPath };
          triggerSSO(ssoProps);
        }
        global?.localStorage?.removeItem("userEmail");
        setSuccess(true);
      }
    }
  };

  const error = getErrorStyle(response, api, mode);
  const wrapperStyle = displaySuccess ? `auth--wrapper ${mode} success-wrapper` : `auth--wrapper ${mode}`;
  return (
    <div className={wrapperStyle}>
      <CustomHeadline
        headline={enterOtpTitle || EMAIL_OTP_HEADLINE}
        editData={displayData || updatedInputData}
        onEdit={triggerOnEdit}
        id="email-otp-headline"
      />
      <div className={error} styleName="input-wrapper">
        <label for="otp">{enterOtpLabel || ENTER_OTP}</label>
        <input
          inputmode="numeric"
          pattern="[0-9]*"
          value={otp}
          id="otp"
          onChange={(event) => {
            setResponse(null);
            setApi(null);
            setOtp(retrieveNumbers(event.target.value));
          }}
          name="otp"
          required
        />
        {inputFieldError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
        <ResendOtp
          resendOtpLabel={resendOtpLabel}
          resendOtpInLabel={resendOtpInLabel}
          setResponse={setResponse}
          email={updatedInputData}
          setApi={setApi}
        />
      </div>
      <Button
        text={button || VERIFY_SIGN_IN_BUTTON}
        clickHandler={() => triggerHandler()}
        disable={!otp}
        enableEnterClick={true}
      />
      {genericError(response, api) ? <ErrorMessage response={response} api={api} mode={mode} /> : <></>}
      <AgreementText customAgreementText={agreementText} currentScreen="sign-up" />
      {displaySuccess ? (
        <SuccessMessage message={signupSuccess || SIGN_UP_SUCCESS} mode={mode} isUserLoginPage={isUserLoginPage} />
      ) : (
        <></>
      )}
    </div>
  );
};
